export default __webpack_public_path__ + "static/media/mini1.86010791.png";